import { render } from "./Tvl.vue?vue&type=template&id=9b168bb0&scoped=true&ts=true"
import script from "./Tvl.vue?vue&type=script&lang=ts"
export * from "./Tvl.vue?vue&type=script&lang=ts"

import "./Tvl.vue?vue&type=style&index=0&id=9b168bb0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b168bb0"]])

export default __exports__